export const DATA_PRODUCER_WORKSHEET_NAME = "DataProducer";
export const DATA_SOURCE_WORKSHEET_NAME = "DataSource";

export const YieldTypes = ["bid", "ask"];

export const DATA_UPDATED_FILL_COLOR = "#FFCE73";
export const DATA_UPDATED_FONT_COLOR = "#6C2B00";
